const SET_ENTITLEMENT = 'SET_ENTITLEMENT';
const SET_APP_ENTITLEMENT = 'SET_APP_ENTITLEMENT';
const SET_MENU_MAPPED_LIST = 'SET_MENU_MAPPED_LIST';

export default {
    SET_ENTITLEMENT,
    SET_APP_ENTITLEMENT,
    SET_MENU_MAPPED_LIST
}